export default "__VITE_ASSET__544951c5__"